"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("@emotion/react");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var StaticItem_1 = __importDefault(require("../../common/StaticItem"));

var frontend_application_1 = require("@ryerson/frontend.application");

var util_1 = require("../../common/util");

var Menu_content_1 = require("../../common/Menus/Menu.content");

var PhoneLinkRenderer_1 = require("../../Renderers/PhoneLinkRenderer");

var frontend_common_1 = require("@ryerson/frontend.common");

var util_2 = require("../../common/util");

var Menu_data_1 = require("../../common/Menus/Menu.data");

var HeaderConfig_1 = require("../../common/HeaderConfig/HeaderConfig");

var FooterTermsPrivacyLinks_1 = require("../../Renderers/FooterTermsPrivacyLinks");

var StyledComponents_1 = require("../Helpers/StyledComponents");

var FooterSocialLinksRenderer_1 = require("../../Renderers/FooterSocialLinksRenderer");

var FullFooterDesktop = function FullFooterDesktop(_ref) {
  var companyName = _ref.companyName,
      footerData = _ref.footerData,
      storeDirectory = _ref.storeDirectory,
      isLoggedIn = _ref.isLoggedIn,
      _ref$token = _ref.token,
      token = _ref$token === void 0 ? "" : _ref$token;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      _ref3$localization = _ref3.localization,
      language = _ref3$localization.language,
      country = _ref3$localization.country;

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var _ref4 = (0, react_1.useState)([]),
      _ref5 = _slicedToArray(_ref4, 2),
      customerPortalMenu = _ref5[0],
      setPortalMenu = _ref5[1];

  var _ref6 = (0, react_1.useState)(frontend_common_1.withTranslation.metalFinder[language]),
      _ref7 = _slicedToArray(_ref6, 2),
      metalFinderText = _ref7[0],
      setMetalFinderText = _ref7[1];

  var headerSettings = HeaderConfig_1.headerConfigData[companyName];

  var buildCustomerPortalMenu = function buildCustomerPortalMenu() {
    var defaultMenuList = [];

    var _iterator = _createForOfIteratorHelper(Menu_data_1.myAccountMenuDefaultItems),
        _step;

    try {
      var _loop = function _loop() {
        var id = _step.value;
        var foundItem = Menu_data_1.accountMenuData.find(function (itm) {
          return itm.id === id;
        });
        var isEnabled = foundItem;
        var permission = foundItem && (0, util_1.checkMenuItemPermission)(foundItem.id, token); //convert to new model for this footer

        var newItem = Object.assign(Object.assign({}, foundItem), {
          display: translate(foundItem === null || foundItem === void 0 ? void 0 : foundItem.id),
          value: storeDirectory + (foundItem === null || foundItem === void 0 ? void 0 : foundItem.url)
        });
        foundItem && isEnabled && permission && defaultMenuList.push(newItem);
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return defaultMenuList;
  };

  react_1.default.useEffect(function () {
    setHasMounted(true);
  }, []);
  (0, react_1.useEffect)(function () {
    if (hasMounted) {
      setPortalMenu(buildCustomerPortalMenu());
    }
  }, [hasMounted, language, token]);
  (0, react_1.useEffect)(function () {
    setMetalFinderText(frontend_common_1.withTranslation.metalFinder[language]); //setSearchPlaceholderText(withTranslation.search[language]);

    setPortalMenu(buildCustomerPortalMenu());
  }, [language]);

  function translate() {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var hasLabel = !!Menu_content_1.withTranslation[label];
    return hasLabel ? Menu_content_1.withTranslation[label][language] : label;
  }

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      darkGray = _theme$colors$primary.darkGray,
      gray = _theme$colors$primary.gray,
      lighterGray = _theme$colors$primary.lighterGray,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      primaryBrand = _theme$colors$primary.primaryBrand;

  var renderLinks = function renderLinks(links, storeLink) {
    return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
      children: links.map(function (link, index) {
        return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
          children: link.display !== "" ? (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
            children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
              type: "tertiary",
              to: link.value || "",
              disabled: !link.active,
              gatsby: (0, util_2.isGatsbyLink)(storeLink, storeDirectory),
              size: "sm",
              color: link.active ? white : gray,
              children: link.display
            })
          }) : (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
            children: "\xA0"
          })
        }, "link-".concat(index));
      })
    });
  };

  return (0, jsx_runtime_1.jsx)(StyledComponents_1.StyledFooter, {
    backColor: secondaryBrand,
    borderColor: lighterGray,
    className: "footer-desktop",
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Container, {
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "center",
        style: (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t\t"]))),
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          grow: 1,
          children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country)
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: StyledComponents_1.flexWidth,
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "contactUs",
            color: white,
            type: "tertiary"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: StyledComponents_1.flexWidth,
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "locations",
            color: white,
            type: "tertiary"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: StyledComponents_1.flexWidth,
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "lg",
            color: white,
            css: (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\topacity: 0.2;\n\t\t\t\t\t\t\t"]))),
            children: "|"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: StyledComponents_1.flexWidth,
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "liveChat",
            color: white,
            type: "tertiary"
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            label: "",
            onClick: function onClick() {
              if (window && window.LiveChatWidget) window.LiveChatWidget.call("maximize");
            },
            background: primaryBrand,
            size: "sm",
            foreground: "light",
            leftIcon: "comment",
            shape: "circle"
          })
        })]
      }), (0, jsx_runtime_1.jsx)(StyledComponents_1.FullWidthDivider, {
        color: white
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        style: (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 74px;\n\t\t\t\t\t"]))),
        justifyContent: "space-between",
        children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "column-1",
          style: StyledComponents_1.menuColumn,
          children: [(0, jsx_runtime_1.jsxs)(StyledComponents_1.List, {
            children: [footerData === null || footerData === void 0 ? void 0 : footerData.column1Links.map(function (link, index) {
              return (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
                children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                  disabled: link.url ? false : true,
                  to: link.url ? link.url : "",
                  size: "sm",
                  gatsby: (0, util_2.isGatsbyLink)(false, storeDirectory),
                  color: link.url ? white : gray,
                  children: link.label
                })
              }, "item-".concat(index));
            }), (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
              children: (0, jsx_runtime_1.jsx)(StyledComponents_1.MetalFinder, {
                children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                  to: "/store/",
                  gatsby: false,
                  children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                    label: metalFinderText,
                    background: darkGray,
                    foreground: "light",
                    shape: "rounded",
                    onClick: function onClick() {},
                    size: "sm"
                  })
                })
              })
            }), headerSettings.globalMenus.showStockList && (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
              children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
                itemName: "getStocklist",
                color: white,
                type: "tertiary"
              })
            })]
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
            children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
              to: "".concat(storeDirectory, "/credit-application"),
              size: "sm",
              gatsby: (0, util_2.isGatsbyLink)(true, storeDirectory),
              color: white,
              dataTestId: "link-click",
              children: frontend_common_1.withTranslation.creditApplication[language]
            })
          })]
        }), isLoggedIn && customerPortalMenu && (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "column-2",
          style: StyledComponents_1.menuColumn,
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            color: white,
            weight: "bold",
            children: frontend_common_1.withTranslation.customerPortal[language]
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
            color: white
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.List, {
            children: renderLinks(customerPortalMenu, true)
          })]
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "column-2",
          style: StyledComponents_1.menuColumn,
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            color: white,
            weight: "bold",
            children: footerData.column2Title
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
            color: white
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.List, {
            children: footerData === null || footerData === void 0 ? void 0 : footerData.column2Links.map(function (link, index) {
              return (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
                children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                  disabled: link.url ? false : true,
                  to: link.url ? link.url : "",
                  size: "sm",
                  gatsby: (0, util_2.isGatsbyLink)(false, storeDirectory),
                  color: link.url ? white : gray,
                  children: link.label
                })
              }, "item-".concat(index));
            })
          })]
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "column-3",
          style: StyledComponents_1.menuColumn,
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            color: white,
            weight: "bold",
            children: footerData.column3Title
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
            color: white
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.List, {
            children: footerData === null || footerData === void 0 ? void 0 : footerData.column3Links.map(function (link, index) {
              return (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
                children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                  disabled: link.url ? false : true,
                  to: link.url ? link.url : "",
                  size: "sm",
                  gatsby: (0, util_2.isGatsbyLink)(false, storeDirectory),
                  color: link.url ? white : gray,
                  children: link.label
                })
              }, "item-".concat(index));
            })
          })]
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          className: "column-4",
          style: StyledComponents_1.menuColumn,
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            color: white,
            weight: "bold",
            children: footerData.column4Title
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
            color: white
          }), (0, jsx_runtime_1.jsx)(StyledComponents_1.List, {
            children: footerData === null || footerData === void 0 ? void 0 : footerData.column4Links.map(function (link, index) {
              return (0, jsx_runtime_1.jsx)(StyledComponents_1.ListItem, {
                children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                  disabled: link.url ? false : true,
                  to: link.url ? link.url : "",
                  size: "sm",
                  gatsby: (0, util_2.isGatsbyLink)(false, storeDirectory),
                  color: link.url ? white : gray,
                  children: link.label
                })
              }, "item-".concat(index));
            })
          })]
        })]
      }), companyName === HeaderConfig_1.companyNameData.ryerson ? (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        className: "social-and-links",
        style: (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-top: 45px;\n\t\t\t\t\t\t"]))),
        direction: "column",
        children: (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
          children: [(0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "followUs",
            returnType: "text",
            color: gray
          }), (0, FooterSocialLinksRenderer_1.RenderSocialLinks)(white)]
        })
      }) : null, (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
        color: white
      }), (0, FooterTermsPrivacyLinks_1.FooterTermsPrivacyLinksRenderer)(theme), companyName === HeaderConfig_1.companyNameData.ryerson && (0, jsx_runtime_1.jsx)(StyledComponents_1.LogoContainer, {
        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.RyersonLogo, {
          color: "white",
          width: "100%"
        })
      }), companyName === HeaderConfig_1.companyNameData.southernToolSteel && (0, jsx_runtime_1.jsx)(frontend_assets_1.STSLogo, {
        color: "white",
        width: "100%"
      })]
    })
  });
};

exports.default = FullFooterDesktop;